import React, { useState, useEffect, useContext } from 'react'
import { strCol, intCol, dateCol } from '@integec/grid-tools/lib/cols'
// import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getWindSubgroupInactive,
  postWindSubgroupInactive,
  deleteWindSubgroupInactive,
  getWindSubgroup,
} from 'api/pgads.js'
// import { getCompanyNameMap, getUtilityNameMap } from 'core/selectors'
import CommonScreen from 'admin/component/CommonScreen'
import { Select, Button, DatePicker, InputNumber } from 'antd'
import R from 'ramda'
import styled from 'styled-components'
import { ErrorContext } from 'context'

const TableTD = styled.td`
  text-align: end;
`

const windInactiveHeaders = [
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    width: 200,
  }),
  strCol({ ident: 'subgroupId', display: 'Subgroup', isKey: true, width: 200 }),
  intCol({
    ident: 'numberMbTurbine',
    display: 'Number MB Turbine',
    isFiltered: true,
    width: 170,
  }),
  intCol({
    ident: 'numberIrTurbine',
    display: 'Number IR Turbine',
    isFiltered: true,
    width: 170,
  }),
  intCol({
    ident: 'numberRuTurbine',
    display: 'Number RU Turbine',
    isFiltered: true,
    width: 170,
  }),
  modifierCol,
  modifiedDateCol,
]
const retrieveTask = apiTargetInfo => getWindSubgroupInactive(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postWindSubgroupInactive(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteWindSubgroupInactive(apiTargetInfo)(data)

const title = 'Wind Subgroup Inactive'

const WindInactive = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [subgroupNameMap, setSubgroupMap] = useState({})
  const { setError } = useContext(ErrorContext)
  useEffect(
    _ =>
      getWindSubgroup(apiTargetInfo).fork(setError, data => {
        const mapData = R.compose(
          R.reduce((a, b) => ({ ...a, ...b }), {}),
          R.map(d => ({ [d.subgroupId]: d.subgroupName }))
        )(data)
        setSubgroupMap(mapData)
      }),
    [apiTargetInfo, setError]
  )

  const headerWithFormatter = windInactiveHeaders.map(header =>
    header.ident === 'subgroupId'
      ? {
          ...header,
          dataFormatter: ({ value }) => subgroupNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            subgroupNameMap[rowData.subgroupId] || rowData.subgroupId,
        }
      : header
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Subgroup:</TableTD>
            <td>
              <Select
                style={{ minWidth: '200px' }}
                onChange={value =>
                  setInsertData({ ...insertData, subgroupId: value })
                }
                value={insertData.subgroupId}
              >
                {Object.keys(subgroupNameMap).map(k => (
                  <Select.Option key={k} value={k}>
                    {subgroupNameMap[k]}
                  </Select.Option>
                ))}
              </Select>
            </td>
            <TableTD>Effective Date:</TableTD>
            <td style={{ minWidth: '150px' }}>
              <DatePicker
                format="MM/DD/YYYY"
                value={insertData.selectedDate}
                onChange={d => {
                  setInsertData({
                    ...insertData,
                    selectedDate: d,
                    effectiveDate: d.format('YYYY-MM-DD'),
                  })
                }}
              />
            </td>
            {/* </tr>
          <tr> */}
            <TableTD>MB Turbine:</TableTD>
            <td>
              <InputNumber
                vaue={insertData.numberMbTurbine}
                onChange={val =>
                  setInsertData({ ...insertData, numberMbTurbine: val })
                }
                min={0}
              />
            </td>
            <TableTD>IR Turbine:</TableTD>
            <td>
              <InputNumber
                vaue={insertData.numberIrTurbine}
                onChange={val =>
                  setInsertData({ ...insertData, numberIrTurbine: val })
                }
                min={0}
              />
            </td>
            <TableTD>RU Turbine:</TableTD>
            <td>
              <InputNumber
                vaue={insertData.numberRuTurbine}
                onChange={val =>
                  setInsertData({ ...insertData, numberRuTurbine: val })
                }
                min={0}
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.utility}
      autoRetrieve
      widthOffset={150}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      // onRetrieveData={reloadUtilityNameMap}
      sortEnabled
      // sortOnData={sortOnData}
      // sortOptions={[
      //   strCol({
      //     ident: 'plantIdName',
      //     sortOrder: 'asc',
      //   }),
      //   strCol({
      //     ident: 'utility',
      //     sortOrder: 'asc',
      //   }),
      // ]}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  //      companyNameMap: getCompanyNameMap(state),
  // utilityNameMap: getUtilityNameMap(state),
})
// eslint-disable-next-line no-unused-vars
const mapDispatchToMap = dispatch => ({
  // saveUtility: utilities =>
  //   dispatch({ type: STORE_UTILITY, payload: utilities }),
})

export default connect(mapStateToProps, mapDispatchToMap)(WindInactive)
